import { AxiosError } from 'axios'

interface ResolveAuthErrorMessageOptions {
  credentialsMessage?: string
  fallbackMessage?: string
  forbiddenMessage?: string
}

export function resolveAuthErrorMessage(
  error: unknown,
  options: ResolveAuthErrorMessageOptions = {}
): string {
  const {
    credentialsMessage,
    fallbackMessage = 'Une erreur est survenue. Veuillez réessayer.',
    forbiddenMessage,
  } = options

  if (error instanceof AxiosError) {
    const status = error.response?.status
    const apiMessage =
      typeof error.response?.data === 'object' &&
      error.response?.data !== null &&
      'message' in error.response.data &&
      typeof error.response.data.message === 'string'
        ? error.response.data.message
        : undefined

    if (forbiddenMessage && status === 403) {
      return forbiddenMessage
    }

    if (credentialsMessage && (status === 400 || status === 401)) {
      return credentialsMessage
    }

    if (status && status >= 500) {
      return 'Une erreur interne est survenue. Veuillez réessayer.'
    }

    if (apiMessage === 'Internal server error') {
      return 'Une erreur interne est survenue. Veuillez réessayer.'
    }

    if (apiMessage) {
      return apiMessage
    }
  }

  return fallbackMessage
}
